import React, { useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { useRouteMatch } from 'react-router-dom';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

import { OrganizationDetails } from '../generated-api';
import LimberApi from '../api/LimberApi';

interface Props {
  organization: OrganizationDetails;
}

const PurchaseButton: React.FunctionComponent<Props> = (props) => {
  const classes = useStyles(props);
  const stripe = useStripe();
  const { url } = useRouteMatch();
  const [loading, setLoading] = useState(false);

  if (stripe == null) return null;

  const { organization } = props;

  const purchase = async () => {
    if (stripe == null || organization == null) return;

    const { location } = window;
    const currentUrl = `${location.protocol}//${location.host}${url}`;

    setLoading(true);
    const { sessionId } = await LimberApi.beginPaymentPost({
      body: {
        organizationId: organization.id,
        successUrl: `${currentUrl}/success`,
        cancelUrl: currentUrl,
      },
    });

    await stripe.redirectToCheckout({ sessionId });
    setLoading(false);
  };

  return (
    <Box className={classes.wrapper}>
      <Button
        variant="contained"
        color="primary"
        onClick={purchase}
        disabled={loading}
        classes={{
          root: classes.button,
          label: classes.buttonText,
        }}
      >
        Purchase your 8-week program
      </Button>
      {loading && (
        <CircularProgress
          size={36}
          thickness={6}
          className={classes.progress}
        />
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'inline-block',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  button: {
    padding: theme.spacing(4),
    borderRadius: 0,
  },
  buttonText: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  progress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -18,
    marginLeft: -18,
  },
}));

export default PurchaseButton;
